import productPlaceholder from "../../../../assets/images/placeholder.png";

export const PRODUCT_LOGO_PLACEHOLDER = productPlaceholder;

export const DEFAULT_LOGO_SETTINGS = {
    headerUrl: "",
    headerWidth: "96",
    footerUrl: "",
    footerWidth: "56",
};

export const LOGO_GO_SRC = {
    header: "{{.StoreLogo}}",
    footer: "{{.StoreLogoSmall}}",
};
